import { useCallback, useState } from 'react';
const EMPTY_MODAL = {
  visible: false,
  confirmArgs: {},
};

const useConfirmModal = () => {
  const [modalProps, setModalProps] = useState(EMPTY_MODAL);
  const confirm = useCallback((args) => {
    return new Promise((resolve) => {
      setModalProps({
        visible: true,
        confirmArgs: args,
        onClose: (result) => {
          /* SURF-4841: the question stays while the dialog closes. Radix keeps the content
             mounted for its fade-out, and resetting to EMPTY_MODAL here emptied the title
             and the message in the same update, so the dialog faded out as "Confirm" and
             "Are you sure?" (ConfirmModal's fallbacks) right after the admin confirmed
             "Unpublish Page". `onClose` is still dropped, so a second click during the
             fade cannot resolve twice. */
          setModalProps({ visible: false, confirmArgs: args });
          resolve(result);
        },
      });
    });
  }, []);
  return {
    confirm,
    confirmProps: modalProps,
  };
};

export default useConfirmModal;
